import { useDispatch, useSelector } from 'react-redux';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import SuspendedSelectionLabel from 'modules/betslip/betslip-view/bet-components/suspended-selection-label/index.js';

const { PRICE_TYPE } = MojitoServices.Bets.types;
const { Dropdown } = MojitoPresentation.Components;
const { actions: betslipActions, utils: BetslipUtils } = MojitoServices.Betslip;
const EventUtils = MojitoServices.SportsContent.Events.utils;
const { selectOddsFormat } = MojitoServices.UserSettings.selectors;

const OddsDropdown = ({
    bet,
    prices,
    mojitoTools: { l10n, config, appContext },
    hasOddsChange,
    suspended,
    expired,
}) => {
    const dispatch = useDispatch();
    const { emitAnalytics } = appContext.analyticsEmitter;
    const sportId = BetslipUtils.getFirstBetPart(bet).partInfo?.sportId;
    const oddsFormat = useSelector(selectOddsFormat);

    if (suspended || expired) {
        return (
            <SuspendedSelectionLabel expired={expired} config={config.suspendedSelectionLabel} />
        );
    }

    const items = prices.map(price => {
        const { type, betRef } = price;
        const odds = EventUtils.getOdds(price, oddsFormat, l10n);
        return {
            value: betRef,
            label: EventUtils.getDisplayedOdds(odds, type, l10n),
        };
    });

    const selectedItemValue = prices.find(({ type }) => type === bet.priceType)?.betRef;

    const cbOnChange = betRef => {
        dispatch(betslipActions.updatePart({ betRef, betId: bet.id }));
        sportId && emitAnalytics('betslipPriceTypeDropdownChange', sportId);
    };

    let dropDownConfig = config.dropdown;
    if (hasOddsChange && bet.priceType === PRICE_TYPE.LP) {
        dropDownConfig = config.dropdownHighlight;
    }

    return (
        <Dropdown
            items={items}
            config={dropDownConfig}
            cbOnChange={cbOnChange}
            class={'ta-OddsDropdown'}
            triggerOverlayInteraction={false}
            selectedItemValue={selectedItemValue}
        />
    );
};

export default OddsDropdown;
